module.exports = __webpack_public_path__ + "static/media/filter-icon.d96d0a8c.svg";